<template>
  <div class="el-home">

      <el-header class="el-top-header">

        <el-row type="flex">
          <el-col :span="12" class="hidden-sm-and-down">
            <div class="header-logoName" >
              <img src="../images/logo.png" alt="logo" class="logo">
              <div class="header-loginTitle">
                <div class="header-login_P1_Title">{{$t('login.loginTitle')+ sysName}}</div>
                <div class="header-login_p2_Title">{{$t('login.loginSubTitle')}}</div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" justify="end">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6" style="display: flex">
                <div class="header-systemTypeBtnList hidden-sm-and-down">
                  <el-menu class="el-menu-demo" mode="horizontal" text-color="#000" active-text-color="rgba(117, 116, 249, 1)">
                    <el-submenu index="1">
                      <template slot="title">快捷访问</template>
                      <el-menu-item ><a href="http://imsmanage.efercro.com/" target="_blank">去美国服务器</a></el-menu-item>
                      <el-menu-item ><a href="http://eumanage.efercro.com/" target="_blank">去欧洲服务器</a></el-menu-item>
                      <el-menu-item ><a href="http://47.242.135.72:19300/" target="_blank">去测试服务器</a></el-menu-item>
                    </el-submenu>
                  </el-menu>
                </div>
                <div class="header-systemMenuBtnList hidden-sm-and-up" @click="drawer = true">
                  菜单<i class="el-icon-s-unfold"></i>
                </div>
                <div class="header-systemTypeBtnList">

                  <div>
                    <el-menu class="el-menu-demo" :default-active="'k'+activeIndex" mode="horizontal" text-color="#000" active-text-color="rgba(117, 116, 249, 1)">
                      <el-submenu index="1">
                        <template slot="title">系统入口</template>
                        <el-menu-item  v-for="item in SystemList" :key="item.systemId" @click="setActiveIndex(item)" :index="'k'+item.systemId">{{item.sysName}}</el-menu-item>
                      </el-submenu>
                    </el-menu>
                  </div>



                </div>
              </el-col>
              <el-col class="hidden-sm-and-down" :xs="12" :sm="12" :md="6" :lg="4" :xl="4" >
                <div class="header-system">
                  <div class="userinfo-icon">
                    <el-avatar fit="fill" src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"></el-avatar>
                  </div>
                  <div class="userinfo-txt">
                    {{ username }}
                  </div>
                  <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link userinfo-inner">
                    <i class="iconfont el-icon-liebiaoshitucaidan" style="font-size: 24px"></i>
                  </span>
                    <el-dropdown-menu slot="dropdown">
                      <!-- <el-dropdown-item command="userview">我的消息</el-dropdown-item> -->
                      <el-dropdown-item command="editpass">{{$t('home.editPasswd')}}</el-dropdown-item>
                      <el-dropdown-item command="signout">{{$t('home.exitLogin')}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-header>

      <el-container class="home-main">
        <div class="home-main-left-menu hidden-sm-and-down">
          <div class="system-name">{{systemName}}</div>
          <systemMenu :menuData="menus" v-if="isMenuShow"></systemMenu>
        </div>

        <!-- 右边主页面部分 -->
        <el-main :class="isMenuShow?'main-box-true':''">
          <div class="tabs-switch-page" v-if="isMenuShow">
            <el-tag size="medium" v-for="(tab, index) in tabList" :key="tab.path"
                    @close="handleClose(tab.path, index)" @click="handleChangeCurrentTab(tab)"
                    :closable=" tab.type !== 1" :effect="activePath === tab.path ? 'dark' : 'plain'">
              {{tab.title}}
            </el-tag>
          </div>
          <keep-alive :include="this.aliveViews">
            <router-view v-if="isRouterAlive"></router-view>
          </keep-alive>
        </el-main>
      </el-container>

      <el-dialog title="修改密码" v-loading="editpassloading" :visible.sync="dialogFormVisible" center>
        <el-form :model="userpass" ref="userpass" :rules="rules">
          <el-form-item label="原密码" :label-width="formLabelWidth" prop="pass">
            <el-input size="small" v-model="userpass.pass" type="password" auto-complete="off" placeholder="请输入原密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" :label-width="formLabelWidth" prop="editpass">
            <el-input size="small" v-model="userpass.editpass" type="password" auto-complete="off" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" :label-width="formLabelWidth" prop="neweditpass">
            <el-input size="small" v-model="userpass.neweditpass" type="password" auto-complete="off" placeholder="请输入确认密码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelUserPass()">取 消</el-button>
          <el-button size="small" type="primary" @click="userEditpass('userpass')">确 定</el-button>
        </div>
      </el-dialog>


    <el-drawer
      title="菜单"
      :visible.sync="drawer"
      direction="ltr"
      size="51%"
      >
      <div class="home-main-left-menu">
        <div class="system-name">{{systemName}}</div>
        <systemMenu :menuData="menus" v-if="isMenuShow"></systemMenu>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import md5 from 'md5'
import systemMenu from "../common/menu";
import { mapState, mapMutations } from 'vuex';
import { selectRoleSystemListByRoleIdApi } from '../api/user/role'
import 'element-ui/lib/theme-chalk/display.css';
import sha1 from "sha1";
export default {
  // 注册组件
  components: {
    systemMenu
  },
  computed: {
    ...mapState({ // 从 state 中的到的计算属性
      activePath: state => state.activePath, // 已选中菜单
      tabList: state => state.tabList,  // tag菜单列表
    }),
    aliveViews() {
      return this.tabList.filter((item) => item.isAlive).map((tab) => tab.name);
    },
    fullPath: function() {
      return this.$route.params;
    }
  },
  provide (){
    return {
      reload : this.reload
    }
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value !== this.userpass.editpass) {
        return callback(new Error('两次输入密码不一致'))
      } else {
        return callback()
      }
    }
    return {
      userType: 4,
      isRouterAlive: true,
      systemName: null,
      sysName: null,
      menus: [],
      username: window.sessionStorage.userName,
      roleId: window.sessionStorage.roleId,
      editpassloading: false,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      userpass: {
        pass: '',
        editpass: '',
        neweditpass: ''
      },
      rules: {
        pass: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, message: '请输入密码长度6位数以上字符', trigger: 'blur' }
        ],
        editpass: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '请输入密码长度6位数以上字符', trigger: 'blur' }
        ],
        neweditpass: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, message: '请输入密码长度6位数以上字符', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      SystemList: [],
      activeIndex: '1', // 默认选中
      homeLoading: false,
      admin: window.sessionStorage.userLogin , // 超级管理员账户，勿删
      carryOn: window.sessionStorage.roleId, // 随身打角色id：8,勿删
      isMenuShow: false,
      drawer: false
    }
  },
  mounted () {
    this.sysName = window.sessionStorage.systemName
    // 获取角色项目系统
    this.getSystem();
  },
  watch: {
    $route(newRoute) {
      // 监听路由变化往多标签数组新增
      let { path, meta: { title }, name} = newRoute;
      this.$store.commit('changeMenu', path)
      let current = this.$router.history.current
      this.$store.commit('selectMenu', { path, title, name, isAlive: true, type: 2,params: current.params, query:current.query  })
    },
    getIsMenu(val) {
      this.isMenuShow = val
    }

  },
  methods: {
    // 初始化加载-菜单
    async loadTreeMenu () {
      // 默认系统类型
      await this.$axiosPost(this.$api.queryHomeTreeMenu, {sysMid: this.$store.state.systemId, roleId: this.roleId}).then(res => {
        if (res.code === this.http.OK) {
          this.menus = res.data.treeMenu
          this.isMenuShow = this.menus.length > 0;
        } else {
          this.$notify.error({ message: res.msg })
        }
      })
    },
    // 取消修改密码弹出框
    cancelUserPass () {
      this.$refs.userpass.resetFields()
      this.dialogFormVisible = false
    },
    // 修改密码
    userEditpass (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editpassloading = true
          this.$axiosPost(this.$api.editpassapi, {
            pass: md5(this.userpass.pass),
            editpass: md5(this.userpass.editpass)
          }).then(res => {
            if (res.code === this.http.OK) {
              this.$notify.success({ message: '修改密码成功' })
              this.$refs.userpass.resetFields()
              this.editpassloading = false
              this.dialogFormVisible = false
              this.$router.push({path: '/'})
            } else {
              this.editpassloading = false
              this.$notify.error({ message: res.msg })
            }
          })
        }
      })
    },
    // 个人中心
    handleCommand (command) {
      switch (command) {
        case 'userview':
          break
        case 'editpass':
          this.dialogFormVisible = true
          break
        case 'signout':
          this.singout()
          break
        default: break
      }
    },
    singout () {
      window.sessionStorage.token = ''
      window.sessionStorage.clear()
      this.$router.push('/')
    },
    // 导航栏上的按钮
    setActiveIndex (item) {
      this.activeIndex = item.systemId
      this.$store.commit('setSystem', this.activeIndex);
      this.getLoginUserInfo2(item)
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick( ()=>{
        this.isRouterAlive = true
      })
    },
    // 获取系统用户信息(渠道商下所有的机型id)
    getLoginUserInfo() {
      this.$axiosPost(this.$api.getLoginUserInfoApi,{projectId: this.$store.state.systemId}).then(res =>{
        if(res.code === this.http.OK){

          this.userType = res.data.userType
          if (this.userType === 4) { // 当用户类型是4客户时，跳转特定页
            this.$router.push({path: r.data.homePath,query: {id: res.data.id}})
          }else {
            this.modeIdList = res.data.modelList
            this.$store.commit('setModelList', res.data.modelList)
            if ( res.data.appChannelList.length > 0) {
              let appChannelList =  res.data.appChannelList.toString();
              this.$store.commit('setAppChannelList', appChannelList)
            }else {
              this.$store.commit('setAppChannelList', "")
            }
            this.$store.commit('setChannel', res.data.channelId)
            // 根据路由跳转
            let nextRouter = this.$store.state.tabList[this.$store.state.tabIndex]
            if (nextRouter.params && Object.keys(nextRouter.params).length > 0) {
              this.$router.push({ name: nextRouter.name, params: nextRouter.params });
            } else {
              this.$router.push({ path: nextRouter.path, query: nextRouter.query });
            }
            this.reload()
          }
        }
      })
    },
    getLoginUserInfo2(item) {
      const loading = this.$loading({
        lock: true,
        text: '切换中...',
      });
      this.$axiosPost(this.$api.getLoginUserInfoApi,{projectId: this.$store.state.systemId}).then(res =>{
        loading.close();
        if(res.code === this.http.OK){
          this.userType = res.data.userType
          if (this.userType === 4) { // 当用户类型是4客户时，跳转特定页
            this.$router.push({path: r.data.homePath,query: {id: res.data.id}})
          }else {
            this.modeIdList = res.data.modelList
            this.$store.commit('setModelList', res.data.modelList)
            if ( res.data.appChannelList.length > 0) {
              let appChannelList =  res.data.appChannelList.toString();
              this.$store.commit('setAppChannelList', appChannelList)
            }else {
              this.$store.commit('setAppChannelList', "")
            }
            this.$store.commit('setChannel', res.data.channelId)
            this.loadTreeMenu()
            let str = item.sysUrl;
            let urlName = str.substr(1,str.length)
            let tab = [{path: item.sysUrl ,title: '首页',name: urlName, isAlive: true, type: 1 }]
            this.$store.commit('initTabRouterList', tab);
            this.$store.commit('changeMenu', item.sysUrl);
            this.systemName = item.sysName
            this.$store.commit('setSysPrefix', item.sysPrefix);
            this.$store.commit('setSysName', item.sysName);
            this.$store.commit('setIndexUrl', item.sysUrl); // 设置首页Url，刷新页面时候用
            this.$router.push({path: item.sysUrl})
            this.reload()
          }
        }
      })
    },
    // 获取项目系统
    getSystem() {
      this.getMenuCode(window.sessionStorage.roleId)
      this.$axiosPost(this.$api.selectRoleSystemListByRoleIdApi, {roleId: window.sessionStorage.roleId}).then(res =>{
        this.SystemList = res.data
        if (this.SystemList.length > 0) {
          if (this.$store.state.systemId == null) {
            this.activeIndex = this.SystemList[0].systemId
            this.$store.commit('setSystem', res.data[0].systemId);
            this.$store.commit('setSysPrefix', res.data[0].sysPrefix);
            this.$store.commit('setSysName', res.data[0].sysName);
            // 设置默认首页
            this.$store.commit('changeMenu', this.SystemList[0].sysUrl);
            let str = this.SystemList[0].sysUrl;
            let urlName = str.substr(1,str.length)
            let tab = [{path: this.SystemList[0].sysUrl ,title: '首页',name: urlName,isAlive: true, type: 1 }]
            this.systemName = this.SystemList[0].sysName
            this.$store.commit('initTabRouterList', tab);
            this.loadTreeMenu()
            this.getLoginUserInfo();
          }else {
            this.systemName = this.$store.state.sysName
            this.loadTreeMenu()
            this.getLoginUserInfo();
          }

        }
      })

    },
    goCarryOnPage(page) {
      this.$router.push({path: page })
    },
    // 关闭tab标签
    handleClose(path, index) {
      const nextRouter = this.tabList[index + 1] || this.tabList[index - 1];
      this.$store.commit('subtractCurrentTabRouter', { path , index });
      if (path === this.$router.history.current.path) {
        if (nextRouter.params && Object.keys(nextRouter.params).length > 0) {
          this.$router.push({ name: nextRouter.name, params: nextRouter.params });
        } else {
          this.$router.push({ path: nextRouter.path, query: nextRouter.query });
        }
      }
    },
    handleChangeCurrentTab(nextRouter) {
      if (nextRouter.params && Object.keys(nextRouter.params).length > 0) {
        this.$router.push({ name: nextRouter.name, params: nextRouter.params });
      } else {
        this.$router.push({ path: nextRouter.path, query: nextRouter.query });
      }
      this.$store.commit('changeMenu', nextRouter.path)
    },
    // 获取按钮权限指令
    getMenuCode(roleId) {
      this.$axiosPost(this.$api.queryMenuCodeAllapi, {roleId: roleId}).then(res => {
        if (res.code === this.http.OK) {
          window.sessionStorage.buttonpermissions = res.data
        } else {
          this.$notify.error({message: res.msg});
        }
      })
    }
  }
}
</script>

<style lang="less">


</style>



// WEBPACK FOOTER //
// src/views/Home.vue